
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Event } from "@/types";
import { useState } from "react";
import { toast } from "sonner";

interface TicketModalProps {
  event: Event | null;
  isOpen: boolean;
  onClose: () => void;
}

export const TicketModal = ({ event, isOpen, onClose }: TicketModalProps) => {
  const [loading, setLoading] = useState(false);

  const handlePurchase = async () => {
    setLoading(true);
    try {
      // Simulate ID verification and purchase
      await new Promise(resolve => setTimeout(resolve, 1500));
      toast.success("Ticket purchased successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to purchase ticket");
    } finally {
      setLoading(false);
    }
  };

  if (!event) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="glass-card sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{event.name}</DialogTitle>
          <DialogDescription>
            Complete your ticket purchase for Venue #{event.venue_id}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Ticket Price</span>
            <span className="font-semibold">${event.ticket_price}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Date</span>
            <span>{new Date(event.start_time).toLocaleDateString()}</span>
          </div>
          <div className="border-t pt-4">
            <Button
              onClick={handlePurchase}
              className="w-full"
              disabled={loading}
            >
              {loading ? "Verifying ID..." : "Purchase Ticket"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
